import { level, linePlot, maTypeInput, periodInput } from "../definitionHelpers";
import { PALETTE } from "../palette";
import { PRICE_SOURCE } from "../indicatorTypes";
import { priceReader, valuesReader } from "../math/priceSources";
import { fillMovingAverage } from "../math/movingAverages";
import { highestAt, lowestAt } from "../math/windowExtremes";
import { stochasticAt } from "../math/stochastic";

/**
 * Stochastic Oscillator (research §1.4), as TV Stochastic (K = %K,
 * smooth K = Smoothing, smooth D = %D) when MA is SMA: the close between
 * the lowest low and the highest high of %K bars, smoothed by MA over
 * Smoothing (%K), then by MA over %D (%D).
 */
export default {
  id: "stochastic-oscillator",
  name: "Stochastic Oscillator",
  isOscillator: true,
  decimals: 2,
  inputs: [
    periodInput("kPeriod", "%K", 14),
    periodInput("dPeriod", "%D", 3),
    periodInput("smoothing", "Smoothing", 3),
    maTypeInput("maType", "MA"),
  ],
  plots: [
    linePlot("k", "%K", PALETTE.BLUE),
    linePlot("d", "%D", PALETTE.ORANGE),
  ],
  buffers: ["raw"],
  levels: [level(80, PALETTE.AQUA), level(20, PALETTE.YELLOW)],

  calculate: (bars, { kPeriod, dPeriod, smoothing, maType }, series, fromIndex) => {
    const readHigh = priceReader(bars, PRICE_SOURCE.HIGH);
    const readLow = priceReader(bars, PRICE_SOURCE.LOW);
    const range = { type: maType, fromIndex, toIndex: bars.length };

    for (let index = fromIndex; index < bars.length; index += 1) {
      series.raw[index] = stochasticAt(
        bars[index].close,
        highestAt(readHigh, index, kPeriod),
        lowestAt(readLow, index, kPeriod),
        series.raw[index - 1],
      );
    }

    fillMovingAverage({ ...range, read: valuesReader(series.raw), target: series.k, period: smoothing });
    fillMovingAverage({ ...range, read: valuesReader(series.k), target: series.d, period: dPeriod });
  },
};
